export const log = (message: string, prefix = 'main') => {
    console.log(`%c ${prefix}-log! `, 'background: #FFFF00; color: #000', message);

    const printer = document.getElementById('printer');
    if (printer) {
        const li = document.createElement('li');
        li.textContent = message;
        printer.appendChild(li);
    }
};